<template>
  <Transition leave-active-class="flyout-panel--leave" :duration="animationTimeContent">
    <div
      :class="`flyout-panel ${panelDirection}`"
      v-show="open"
      @keydown.esc="open ? $emit('close') : false"
      role="dialog"
      id="flyoutPanel"
      tabindex="-1"
      aria-label="Menu dialog"
    >
      <Transition
        enter-active-class="flyout-panel__background--enter"
        leave-active-class="flyout-panel__background--leave"
        :duration="animationTimeBackground"
      >
        <div
          class="flyout-panel__background"
          v-show="open"
          role="presentation"
          @click="$emit('close')"
        ></div>
      </Transition>

      <Transition
        enter-active-class="flyout-panel__content--enter"
        leave-active-class="flyout-panel__content--leave"
        enter-from-class="flyout-panel__content--enter-from"
        leave-to-class="flyout-panel__content--leave-to"
        :duration="animationTimeContent"
      >
        <div class="flyout-panel__content" v-show="open">
          <slot></slot>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
export default {
  name: "flyout-panel",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    slideFrom: {
      type: String,
      default: "",
    },
    animationTimeContent: {
      type: Number,
      required: false,
      default: 150,
    },
    animationTimeBackground: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  computed: {
    panelDirection() {
      let value = "";

      if (this.slideFrom === "right") {
        value = "flyout-panel--right";
      } else if (this.slideFrom === "left") {
        value = "flyout-panel--left";
      }

      return value;
    },
  },
};
</script>

<style>
.flyout-panel__background {
  background: transparent;
  height: 100%;
  opacity: 0.3;
  position: fixed;
  top: 0;
  transition: opacity 100ms ease-in-out;
  width: 100%;
  left: 0;
  z-index: 10;
}

.flyout-panel__content--enter,
.flyout-panel__content--leave {
  transition: opacity 150ms ease-in-out;
}

.flyout-panel__content--enter-from,
.flyout-panel__content--leave-to {
  opacity: 0;
}

.flyout-panel__content {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 37.5rem;
  z-index: 20;
  overflow: scroll;
  padding: 2.7rem 2rem;
}

/**
  * Slide in from the right
**/
.flyout-panel--right .flyout-panel__content {
  right: 0;
  transition: right 150ms ease-in-out;
}

.flyout-panel--right .flyout-panel__content--enter,
.flyout-panel--right .flyout-panel__content--leave {
  right: -100%;
}
</style>
